import React from 'react'

import {toAbsoluteUrl} from '../../../_template/helpers/CommonFunction';

const NoDataFound = (props) => {
    const {setHtml, className} = props;
    <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
    return (
        <>
            <div className="text-center">
                <img 
                    src={toAbsoluteUrl('media/saiMedia/nodata.png')}
                    className={`${className}`} 
                />
                <h3 className="card-title align-items-start flex-column my-5">
                    <span className="card-label fw-bold text-dark">
                        {setHtml ? setHtml : 'No data found'}
                    </span>
                </h3>
            </div>
        </>
    )
}

export default NoDataFound